import React from 'react';
import TruckFormComponent from './TruckFormComponent';
import { Truck, TruckFormData, TruckFormType } from '../../models/truck';
import { LocationKey, Options } from '../../models/utils';

interface Props {
  truck: Truck;
  submit: (truck: TruckFormData) => void;
  hide: () => void;
  linehaulCompanies: Options;
  customsBrokers: Options;
  truckLoadingRestrictions: { [k:string]: { name: string; all: Options; } };
  selectedLocationKey: LocationKey;
}

// tslint:disable-next-line:variable-name
const EditTruckFormComponent = (props: Props) => <TruckFormComponent type={TruckFormType.EDIT} {...props } />;

export default EditTruckFormComponent;
